// Deutsch

export default {
    'About': '',
    'Company': 'Unternehmen',
    'Contact': 'Kontakt',
    'Email Address': 'E-Mail Adresse*',
    'First Name': 'Vorname',
    'Get In Touch': 'Loslegen',
    'Manage Cookies': '',
    'Media Kit': '',
    'Newsroom': '',
    'Password': '',
    'Privacy Policy': '',
    'Related Case Studies': '',
    'Related Resources': 'Ähnliche Themen',
    'See Case Study': 'Senden',
    'Sign up': 'Anmelden',
    'Submit': 'Einreichen',
    'The Goal': '',
    'View All': 'Alle ansehen',
    'You are missing one or more requred fields': '',
};
